export enum BP42Action {
    Initialization = '@bp42actions/initialization',
    Initialized = '@bp42actions/initialized',
    Finalization = '@bp42actions/finalization',

    Loading = '@bp42actions/loading',

    OpenPopup = '@bp42actions/popup/open',
    ClosePopup = '@bp42actions/popup/close',

    SetProduct = '@bp42actions/product/set',
    RemoveProduct = '@bp42actions/product/remove',

    StartedTyping = '@bp42actions/form/startedTyping',
    FillName = '@bp42actions/form/name/fill',
    FillPhone = '@bp42actions/form/phone/fill',

    SetSubmitResult = '@bp42actions/submit/result',
    FlushSubmitResult = '@bp42actions/submit/flush',
}
